import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../utils/config";
export { ssoLogin };
var ssoLoginQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query SsoLogin($client: String!, $provider: SsoProviders!, $email: String!, $token: String!) {\n    ssoTokens(clientId: $client, provider: $provider, email: $email, providerToken: $token) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n    }\n  }\n"])));
async function ssoLogin(provider, email, token) {
  var data = await wrapQuery('ssoLogin', ssoLoginQuery, {
    client: getClientId(),
    provider: provider,
    email: email,
    token: token
  });
  return data.ssoTokens.tokens;
}